<template>
  <div class="tabbar-box"  ref="dynamicScroll">
    <div class="tabbar-box-header">
      <span v-if="getDynamicAuth.dynamic" class="tabbar-box-header-item" :style="{ color: active !== 'SummoningOrder' ? '#333333' : '#ccc' }" @click="updateTab('Dynamic')">
        动态
        <img v-if="getNewStarCircleCount" class="point" src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/red1.svg"/>
      </span>
      <span  v-if="getDynamicAuth.summongOrder" class="tabbar-box-header-item" :style="{ color: active === 'SummoningOrder' ? '#333333' : '#ccc' }" @click="updateTab('SummoningOrder')" >
        召集令
        <img v-if="getNewTaleCount" class="point" src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/red1.svg"/>
      </span>
      <div :class="{ block: true, tabLeft: active === 'Dynamic', tabRight: active === 'SummoningOrder' }"></div>
    </div>
    <!-- <component v-bind:is="active ? active : 'Dynamic'"></component> -->
    <component v-bind:is="active ? active : 'Dynamic'" :ref="active === 'SummoningOrder' ? 'SummoningOrder' : 'dynamic'"></component>
  </div>
</template>
<script>
import Dynamic from './dyanmicLIst'
import SummoningOrder from '../SummoningOrder/SummoningOrder'
import { remove } from '../../../utils/token'
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('tabbar')
const { mapGetters: messageMapGetters } = createNamespacedHelpers('message')
const { mapActions: dynamicMapActions, mapGetters } = createNamespacedHelpers('dynamicTabbar')
export default {
  components: {
    Dynamic,
    SummoningOrder
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      const { active = '' } = vm.$route.query
      // if (from.name === 'DynamicTetail') {
      //   active = 'dynamic'
      // }
      if (from.name !== 'DynamicTetail' && vm.getNewStarCircleCount) {
        vm.$refs.dynamic.pageInit()
      }
      if (to.params.ispublish && from.name === 'Create') {
        vm.active = ''
        vm.$refs.dynamic.pageInit()
      }
      if (to.params.ispublish && from.name === 'CreateSummoningOrder') {
        vm.$refs.SummoningOrder.pageInit()
      }
      vm.updateTabIndex('dynamic')
      if (active) {
        vm.updateDynamicTabIndex(active)
        vm.active = active
      } else {
        vm.active = ''
        remove('dynamicTabIndex')
        vm.updateDynamicTabIndex('')
      }
    })
  },
  data () {
    return {
      active: ''
    }
  },
  methods: {
    ...mapActions({
      updateTabIndex: 'updateTabIndex'
    }),
    ...dynamicMapActions({
      updateDynamicTabIndex: 'updateDynamicTabIndex'
    }),
    updateTab (tab) {
      this.active = tab
      this.updateDynamicTabIndex(tab)
    }
  },
  computed: {
    ...mapGetters({
      getDynamicTabIndex: 'getDynamicTabIndex'
    }),
    ...messageMapGetters({
      getNewStarCircleCount: 'getNewStarCircleCount',
      getNewTaleCount: 'getNewTaleCount'
    }),
    getDynamicAuth () {
      return this.$store.getters['dynamicAuth/getAuth']
    }
  }
}
</script>
<style lang="scss" scoped>
@keyframes tabLeft {
  from {
    left: calc(23.47% + 5px);
  }
  to {
    left: calc(63.93% + 15px);
  }
}
@keyframes tabRight {
  from {
    left: calc(63.93% + 15px);
  }
  to {
    left: calc(23.47% + 5px);
  }
}
.tabbar-box {
  background: #fff;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  height: calc(100% - 50px);
  .tabbar-box-header {
    box-sizing: border-box;
    height: 49px;
    box-sizing: border-box;
    padding: 0 23.47%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    .tabbar-box-header-item {
      font-size:16px;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-weight:600;
      color:#CCCCCC;
      line-height:22px;
      position: relative;
      display: block;
      height: 22px;
      width: 40px;
    }
    .point {
      position: absolute;
      top: 0;
      right: 0;
      width: 8px;
      height: 8px;
      z-index: 999;
    }
    .block {
      position: absolute;
      bottom: 4px;
      left: calc(23.47% + 5px);
      width:20px;
      height:4px;
      background:rgba(24,204,159,1);
    }
    .tabLeft {
      // animation: tabRight 0.5s;
      left: calc(23.47% + 5px);
    }
    .tabRight {
      // animation: tabLeft 0.5s;
      left: calc(63.93% + 15px);
    }
  }
}
</style>
